import { NuevoPasswordViewModel } from '../../models/viewmodels/UsuarioViewmodel';
import { UsuarioService } from '../../services/usuario.service';
import { Router, ActivatedRoute } from '@angular/router';
var NuevoPasswordComponent = /** @class */ (function () {
    function NuevoPasswordComponent(route, usuarioService, router) {
        var _this = this;
        this.route = route;
        this.usuarioService = usuarioService;
        this.router = router;
        this.usuario = new NuevoPasswordViewModel();
        this.alert = {
            tipo: "success",
            titulo: "",
            mensaje: "",
            visible: false
        };
        this.errores = [];
        this.sub = this.route.params.subscribe(function (params) {
            _this.usuario.usuarioId = params['id'];
        });
        this.subq = this.route.queryParams.subscribe(function (params) {
            _this.usuario.token = params['token'];
        });
    }
    NuevoPasswordComponent.prototype.ngOnInit = function () {
    };
    NuevoPasswordComponent.prototype.modificar = function () {
        var _this = this;
        this.alert.visible = false;
        this.usuarioService.modificarPassword(this.usuario)
            .map(function (result) {
            _this.alert.visible = true;
            _this.alert.closed = false;
            _this.alert.titulo = "Modificar contraseña";
            if (result.status == 201) {
                _this.router.navigate(['login']);
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "Los datos no se han podido actualizar. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
        })
            .subscribe(function (data) {
        }, function (error) {
            var json = error.json();
            _this.alert.visible = true;
            _this.alert.closed = false;
            _this.alert.titulo = "Modificar contraseña";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "Los datos no se han podido actualizar. Por favor vuelva a intentarlo.";
            if (json.modelState) {
                for (var key in json.modelState) {
                    if (json.modelState[key].length == 1) {
                        _this.errores.push(json.modelState[key]);
                    }
                    else {
                        for (var i = 0; i < json.modelState[key].length; i++) {
                            _this.errores.push(json.modelState[key][i]);
                        }
                    }
                }
            }
        });
    };
    NuevoPasswordComponent.ctorParameters = function () { return [{ type: ActivatedRoute }, { type: UsuarioService }, { type: Router }]; };
    return NuevoPasswordComponent;
}());
export { NuevoPasswordComponent };
//# sourceMappingURL=nuevo-password.component.js.map


// WEBPACK FOOTER //
// nuevo-password.component.js